const jsonHeaders = { 'Content-Type': 'application/json' };

async function request(url, options = {}) {
  const response = await fetch(url, {
    credentials: 'include',
    headers: { ...jsonHeaders, ...(options.headers || {}) },
    ...options
  });

  let payload = null;
  try {
    payload = await response.json();
  } catch {
    payload = null;
  }

  if (!response.ok) {
    const mapping = {
      unauthorized: 'Please sign in to continue.',
      invalid_credentials: 'Invalid email or password.',
      slug_in_use: 'That slug is already in use. Please choose another.',
      missing_required_fields: 'Please complete all required fields.',
      portal_env_not_configured: `Portal environment is not configured yet.${payload?.missing?.length ? ` Missing: ${payload.missing.join(', ')}` : ''}`
    };
    const key = payload?.error;
    throw new Error(mapping[key] || payload?.error || `Request failed (${response.status})`);
  }

  return payload;
}

export const portalApi = {
  getSession: () => request('/api/employee/session'),
  login: (email, password) => request('/api/employee/login', { method: 'POST', body: JSON.stringify({ email, password }) }),
  logout: () => request('/api/employee/logout', { method: 'POST' }),
  listAdminArticles: () => request('/api/employee/articles'),
  saveArticle: (article) => request('/api/employee/articles', { method: 'POST', body: JSON.stringify(article) }),
  getPublicArticles: () => request('/api/articles'),
  getPublicArticle: (slug) => request(`/api/articles?slug=${encodeURIComponent(slug)}`)
};
